// extracted by mini-css-extract-plugin
export default {"Separator":"TextSeparator_Separator__kXwe-"};